var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 18,
    viewBox: "0 0 58 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8301 17.6001L23.7001 0.830078H28.2801L25.4101 17.6001H20.8301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9901 1.25006C41.0901 0.930061 39.65 0.560059 37.9 0.560059C33.37 0.560059 30.2001 2.83009 30.1801 6.09009C30.1601 8.50009 32.4501 9.84009 34.1801 10.6501C35.9601 11.4801 36.56 11.9901 36.54 12.7301C36.54 13.8601 35.1301 14.3701 33.8101 14.3701C31.9801 14.3701 31.0101 14.1201 29.5101 13.4901L28.91 13.2101L28.29 16.9601C29.35 17.4501 31.3201 17.8401 33.3801 17.8601C38.1901 17.8601 41.29 15.6201 41.34 12.1201C41.36 10.2201 40.1401 8.77006 37.5001 7.56006C35.9001 6.80006 34.9301 6.29006 34.9301 5.50006C34.9301 4.78006 35.76 4.0401 37.54 4.0401C39.04 4.0201 40.13 4.34006 40.96 4.69006L41.3801 4.88007L41.9901 1.25006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7197 0.860107H50.1797C49.0897 0.860107 48.2597 1.16006 47.7697 2.25006L40.9897 17.6301H45.7797C45.7797 17.6301 46.5698 15.5501 46.7498 15.1101C47.2798 15.1101 51.9297 15.1101 52.5997 15.1101C52.7397 15.6901 53.1597 17.6301 53.1597 17.6301H57.3897L53.7197 0.860107ZM48.0698 11.6601C48.4398 10.7101 49.8997 6.99005 49.8997 6.99005C49.8497 7.04005 50.2698 6.02008 50.4998 5.39008L50.7997 6.82007C50.7997 6.82007 51.6797 10.8201 51.8597 11.6501H48.0698V11.6601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0103 0.860107L12.5202 12.2801L12.0602 9.97009C11.2302 7.29009 8.61021 4.40006 5.72021 2.94006L9.81024 17.6001H14.6402L21.8302 0.860107H17.0103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38995 0.830078H1.01001L0.959961 1.20007C6.66996 2.59007 10.49 5.94009 12.06 9.97009L10.44 2.27008C10.17 1.20008 9.37995 0.880078 8.38995 0.830078Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.791dcf7500e340dda4ff5a0616603895.svg";
export { ForwardRef as ReactComponent };